export const RARITY_CONFIG = {
  common: { name: '普通', color: '#71717a' },
  uncommon: { name: '非凡', color: '#10b981' },
  rare: { name: '稀有', color: '#3b82f6' },
  epic: { name: '史詩', color: '#a855f7' },
  legendary: { name: '傳說', color: '#f59e0b' },
  mythic: { name: '神話', color: '#ef4444' }
};

export const ACHIEVEMENTS_LIST = [
  //==================== 敲擊成就 (8個) ====================
  {
    id: 'first_tap',
    title: '初入佛門',
    description: '第一次敲擊木魚',
    requirement: (state) => state.totalTaps >= 1,
    type: 'tap',
    rarity: 'common',
    icon: '🙏'
  },
  {
    id: 'tap_100',
    title: '誠心正意',
    description: '累計敲擊100次',
    requirement: (state) => state.totalTaps >= 100,
    type: 'tap',
    rarity: 'common',
    icon: '📿'
  },
  {
    id: 'tap_500',
    title: '勤修不輟',
    description: '累計敲擊500次',
    requirement: (state) => state.totalTaps >= 500,
    type: 'tap',
    rarity: 'uncommon',
    icon: '🔔'
  },
  {
    id: 'tap_1000',
    title: '持之以恆',
    description: '累計敲擊1,000次',
    requirement: (state) => state.totalTaps >= 1000,
    unlocksFish: '黃金木魚',
    type: 'tap',
    rarity: 'uncommon',
    icon: '✨'
  },
  {
    id: 'tap_5000',
    title: '功德圓滿',
    description: '累計敲擊5,000次',
    requirement: (state) => state.totalTaps >= 5000,
    type: 'tap',
    rarity: 'rare',
    icon: '💫'
  },
  {
    id: 'tap_10000',
    title: '萬法歸一',
    description: '累計敲擊10,000次',
    requirement: (state) => state.totalTaps >= 10000,
    type: 'tap',
    rarity: 'epic',
    icon: '🌟'
  },
  {
    id: 'tap_50000',
    title: '修行大師',
    description: '累計敲擊50,000次',
    requirement: (state) => state.totalTaps >= 50000,
    type: 'tap',
    rarity: 'legendary',
    icon: '👑'
  },
  {
    id: 'tap_100000',
    title: '不朽傳說',
    description: '累計敲擊100,000次',
    requirement: (state) => state.totalTaps >= 100000,
    type: 'tap',
    rarity: 'mythic',
    icon: '🏛️'
  },

  //==================== 連擊成就 (7個) ====================
  {
    id: 'combo_10',
    title: '初窺門徑',
    description: '達成10次連擊',
    requirement: (state) => state.maxCombo >= 10,
    type: 'combo',
    rarity: 'common',
    icon: '🎯'
  },
  {
    id: 'combo_25',
    title: '漸入佳境',
    description: '達成25次連擊',
    requirement: (state) => state.maxCombo >= 25,
    type: 'combo',
    rarity: 'common',
    icon: '🎪'
  },
  {
    id: 'combo_50',
    title: '心無旁騖',
    description: '達成50次連擊',
    requirement: (state) => state.maxCombo >= 50,
    type: 'combo',
    rarity: 'uncommon',
    icon: '⚡'
  },
  {
    id: 'combo_100',
    title: '專注一致',
    description: '達成100次連擊',
    requirement: (state) => state.maxCombo >= 100,
    unlocksFish: '水晶木魚',
    type: 'combo',
    rarity: 'rare',
    icon: '💎'
  },
  {
    id: 'combo_200',
    title: '天人合一',
    description: '達成200次連擊',
    requirement: (state) => state.maxCombo >= 200,
    type: 'combo',
    rarity: 'epic',
    icon: '🌠'
  },
  {
    id: 'combo_500',
    title: '超凡入聖',
    description: '達成500次連擊',
    requirement: (state) => state.maxCombo >= 500,
    type: 'combo',
    rarity: 'legendary',
    icon: '🔮'
  },
  {
    id: 'combo_1000',
    title: '永恆之擊',
    description: '達成1,000次連擊',
    requirement: (state) => state.maxCombo >= 1000,
    type: 'combo',
    rarity: 'mythic',
    icon: '♾️'
  },

  //==================== 速度成就 (5個) ====================
  {
    id: 'speed_5',
    title: '迅捷之手',
    description: '在0.5秒內連續敲擊',
    requirement: (state) => state.fastestTapInterval < 500,
    type: 'speed',
    rarity: 'common',
    icon: '💨'
  },
  {
    id: 'speed_3',
    title: '快手如風',
    description: '在0.2秒內連續敲擊',
    requirement: (state) => state.fastestTapInterval < 200,
    unlocksFish: '紅寶石木魚',
    type: 'speed',
    rarity: 'rare',
    icon: '🔥'
  },
  {
    id: 'speed_1',
    title: '閃電反射',
    description: '在0.1秒內連續敲擊',
    requirement: (state) => state.fastestTapInterval < 100,
    type: 'speed',
    rarity: 'epic',
    icon: '⚡'
  },
  {
    id: 'perfect_rhythm',
    title: '完美節奏',
    description: '連續10次保持1-2秒的完美間隔',
    requirement: (state) => state.perfectCombo >= 10,
    type: 'speed',
    rarity: 'uncommon',
    icon: '🎵'
  },
  {
    id: 'rhythm_master',
    title: '節奏大師',
    description: '連續30次保持1-2秒的完美間隔',
    requirement: (state) => state.perfectCombo >= 30,
    type: 'speed',
    rarity: 'rare',
    icon: '🎼'
  },

  //==================== 類型成就 (15個) ====================
  {
    id: 'type_master',
    title: '類型大師',
    description: '四種祈福類型各敲擊 50 次',
    requirement: (state) => {
      const requiredTypes = ['merit', 'love', 'wealth', 'health'];
      return requiredTypes.every(type => (state.typeStats[type]?.tapCount || 0) >= 50);
    },
    unlocksFish: '翡翠木魚',
    type: 'type',
    rarity: 'rare',
    icon: '🎭'
  },
  {
    id: 'merit_devotee',
    title: '功德虔誠者',
    description: '功德模式累計 500 次',
    requirement: (state) => (state.typeStats?.merit?.tapCount || 0) >= 500,
    type: 'type',
    rarity: 'uncommon',
    icon: '🙏'
  },
  {
    id: 'buddha',
    title: '佛光普照',
    description: '功德模式累計 1,000 次',
    requirement: (state) => (state.typeStats?.merit?.tapCount || 0) >= 1000,
    type: 'type',
    rarity: 'rare',
    icon: '🌞'
  },
  {
    id: 'merit_legend',
    title: '功德傳說',
    description: '功德模式累計 2,000 次',
    requirement: (state) => (state.typeStats?.merit?.tapCount || 0) >= 2000,
    type: 'type',
    rarity: 'epic',
    icon: '🏛️'
  },
  {
    id: 'love_seeker',
    title: '愛情追尋者',
    description: '愛情模式累計 500 次',
    requirement: (state) => (state.typeStats?.love?.tapCount || 0) >= 500,
    type: 'type',
    rarity: 'uncommon',
    icon: '💕'
  },
  {
    id: 'love_master',
    title: '愛情大師',
    description: '愛情模式累計 1,000 次',
    requirement: (state) => (state.typeStats?.love?.tapCount || 0) >= 1000,
    type: 'type',
    rarity: 'rare',
    icon: '💖'
  },
  {
    id: 'love_legend',
    title: '愛情傳說',
    description: '愛情模式累計 2,000 次',
    requirement: (state) => (state.typeStats?.love?.tapCount || 0) >= 2000,
    type: 'type',
    rarity: 'epic',
    icon: '💝'
  },
  {
    id: 'wealth_collector',
    title: '財富收集者',
    description: '財富模式累計 500 次',
    requirement: (state) => (state.typeStats?.wealth?.tapCount || 0) >= 500,
    type: 'type',
    rarity: 'uncommon',
    icon: '💰'
  },
  {
    id: 'wealth_tycoon',
    title: '財富大亨',
    description: '財富模式累計 1,000 次',
    requirement: (state) => (state.typeStats?.wealth?.tapCount || 0) >= 1000,
    type: 'type',
    rarity: 'rare',
    icon: '💵'
  },
  {
    id: 'wealth_legend',
    title: '財富傳說',
    description: '財富模式累計 2,000 次',
    requirement: (state) => (state.typeStats?.wealth?.tapCount || 0) >= 2000,
    type: 'type',
    rarity: 'epic',
    icon: '💎'
  },
  {
    id: 'health_guardian',
    title: '健康守護者',
    description: '健康模式累計 500 次',
    requirement: (state) => (state.typeStats?.health?.tapCount || 0) >= 500,
    type: 'type',
    rarity: 'uncommon',
    icon: '🍃'
  },
  {
    id: 'health_sage',
    title: '健康聖者',
    description: '健康模式累計 1,000 次',
    requirement: (state) => (state.typeStats?.health?.tapCount || 0) >= 1000,
    type: 'type',
    rarity: 'rare',
    icon: '🌿'
  },
  {
    id: 'health_legend',
    title: '健康傳說',
    description: '健康模式累計 2,000 次',
    requirement: (state) => (state.typeStats?.health?.tapCount || 0) >= 2000,
    type: 'type',
    rarity: 'epic',
    icon: '🌳'
  },
  {
    id: 'balanced_monk',
    title: '平衡修行者',
    description: '四種類型各達到 100 次',
    requirement: (state) => {
      const requiredTypes = ['merit', 'love', 'wealth', 'health'];
      return requiredTypes.every(type => (state.typeStats[type]?.tapCount || 0) >= 100);
    },
    type: 'type',
    rarity: 'uncommon',
    icon: '☯️'
  },
  {
    id: 'ultimate_devotion',
    title: '至高奉獻',
    description: '四種類型各達到 500 次',
    requirement: (state) => {
      const requiredTypes = ['merit', 'love', 'wealth', 'health'];
      return requiredTypes.every(type => (state.typeStats[type]?.tapCount || 0) >= 500);
    },
    type: 'type',
    rarity: 'rare',
    icon: '🏅'
  },

  //==================== 自動敲擊成就 (6個) ====================
  {
    id: 'auto_beginner',
    title: '自動化初探',
    description: '開啟自動敲擊功能',
    requirement: (state) => state.autoTapCount >= 1,
    type: 'auto',
    rarity: 'common',
    icon: '🤖'
  },
  {
    id: 'auto_100',
    title: '機械助手',
    description: '自動敲擊累計 100 次',
    requirement: (state) => state.autoTapTotal >= 100,
    type: 'auto',
    rarity: 'common',
    icon: '⚙️'
  },
  {
    id: 'auto_lover',
    title: '自動化愛好者',
    description: '開啟自動敲擊 10 次',
    requirement: (state) => state.autoTapCount >= 10,
    type: 'auto',
    rarity: 'uncommon',
    icon: '🔁'
  },
  {
    id: 'auto_1000',
    title: '自動化大師',
    description: '自動敲擊累計 1,000 次',
    requirement: (state) => state.autoTapTotal >= 1000,
    type: 'auto',
    rarity: 'uncommon',
    icon: '🔧'
  },
  {
    id: 'auto_5000',
    title: '機械禪師',
    description: '自動敲擊累計 5,000 次',
    requirement: (state) => state.autoTapTotal >= 5000,
    type: 'auto',
    rarity: 'rare',
    icon: '🦾'
  },
  {
    id: 'lazy_master',
    title: '放置大師',
    description: '自動敲擊累計 10,000 次',
    requirement: (state) => state.autoTapTotal >= 10000,
    type: 'auto',
    rarity: 'epic',
    icon: '😴'
  },

  //==================== 特殊成就 (17個) ====================
  // 時間相關
  {
    id: 'night_owl',
    title: '夜貓子',
    description: '在凌晨0-6點敲擊 50 次',
    requirement: (state) => state.nightTaps >= 50,
    type: 'special',
    rarity: 'uncommon',
    icon: '🦉'
  },
  {
    id: 'early_bird',
    title: '早起鳥',
    description: '在早晨6-9點敲擊 50 次',
    requirement: (state) => state.morningTaps >= 50,
    type: 'special',
    rarity: 'uncommon',
    icon: '🐦'
  },
  {
    id: 'midnight_devotion',
    title: '午夜虔誠',
    description: '在凌晨0-6點敲擊 200 次',
    requirement: (state) => state.nightTaps >= 200,
    type: 'special',
    rarity: 'rare',
    icon: '🌙'
  },
  {
    id: 'morning_blessing',
    title: '晨曦祝福',
    description: '在早晨6-9點敲擊 200 次',
    requirement: (state) => state.morningTaps >= 200,
    type: 'special',
    rarity: 'rare',
    icon: '🌅'
  },
  
  // 會話相關
  {
    id: 'session_100',
    title: '單次百擊',
    description: '單次會話敲擊 100 次',
    requirement: (state) => state.sessionTaps >= 100,
    type: 'special',
    rarity: 'common',
    icon: '📝'
  },
  {
    id: 'session_500',
    title: '單次狂熱',
    description: '單次會話敲擊 500 次',
    requirement: (state) => state.sessionTaps >= 500,
    type: 'special',
    rarity: 'uncommon',
    icon: '🔥'
  },
  {
    id: 'session_1000',
    title: '單次千擊',
    description: '單次會話敲擊 1,000 次',
    requirement: (state) => state.sessionTaps >= 1000,
    type: 'special',
    rarity: 'rare',
    icon: '💥'
  },
  {
    id: 'marathon',
    title: '馬拉松修行',
    description: '單次會話敲擊 2,000 次',
    requirement: (state) => state.sessionTaps >= 2000,
    type: 'special',
    rarity: 'epic',
    icon: '🏃'
  },
  
  // 穩定性
  {
    id: 'steady_hand',
    title: '穩定之手',
    description: '連續20次敲擊間隔都在0.8-2秒之間',
    requirement: (state) => {
      if (!state.lastTapIntervals || state.lastTapIntervals.length < 20) return false;
      const last20 = state.lastTapIntervals.slice(-20);
      return last20.every(interval => interval >= 800 && interval <= 2000);
    },
    type: 'special',
    rarity: 'rare',
    icon: '🎯'
  },
  {
    id: 'metronome',
    title: '節拍器',
    description: '連續10次敲擊間隔相差不超過0.1秒',
    requirement: (state) => {
      if (!state.lastTapIntervals || state.lastTapIntervals.length < 10) return false;
      const last10 = state.lastTapIntervals.slice(-10);
      const avg = last10.reduce((a, b) => a + b, 0) / last10.length;
      return last10.every(interval => Math.abs(interval - avg) <= 100);
    },
    type: 'special',
    rarity: 'epic',
    icon: '🎚️'
  },
  
  // 收集類
  {
    id: 'cat_lover',
    title: '貓咪之友',
    description: '累計敲擊2000次',
    requirement: (state) => state.totalTaps >= 2000,
    unlocksFish: '貓咪木魚',
    type: 'special',
    rarity: 'uncommon',
    icon: '🐱'
  },
  {
    id: 'rainbow_master',
    title: '七彩祥雲',
    description: '解鎖5種不同木魚',
    requirement: (state) => {
      const fishUnlockingAchievements = ['tap_1000', 'combo_100', 'speed_3', 'type_master', 'cat_lover'];
      const unlockedFishCount = fishUnlockingAchievements.filter(id =>
        state.unlockedAchievements.includes(id)
      ).length;
      return unlockedFishCount >= 5;
    },
    unlocksFish: '彩虹木魚',
    type: 'special',
    rarity: 'rare',
    icon: '🌈'
  },
  {
    id: 'cosmic_collector',
    title: '宇宙真理',
    description: '達到10000次敲擊',
    requirement: (state) => state.totalTaps >= 10000,
    unlocksFish: '宇宙木魚',
    type: 'special',
    rarity: 'epic',
    icon: '🌌'
  },
  {
    id: 'fish_collector',
    title: '木魚收藏家',
    description: '解鎖所有特殊木魚',
    requirement: (state) => {
      const fishUnlockingAchievements = ['tap_1000', 'combo_100', 'speed_3', 'type_master', 'cat_lover', 'rainbow_master', 'cosmic_collector'];
      return fishUnlockingAchievements.every(id => state.unlockedAchievements.includes(id));
    },
    type: 'special',
    rarity: 'legendary',
    icon: '🏆'
  },
  {
    id: 'achievement_hunter',
    title: '成就獵人',
    description: '解鎖 20 個成就',
    requirement: (state) => state.unlockedAchievements.length >= 20,
    type: 'special',
    rarity: 'uncommon',
    icon: '🎖️'
  },
  {
    id: 'completionist',
    title: '完美主義者',
    description: '解鎖 40 個成就',
    requirement: (state) => state.unlockedAchievements.length >= 40,
    type: 'special',
    rarity: 'rare',
    icon: '💯'
  },
  {
    id: 'true_master',
    title: '真正的大師',
    description: '解鎖所有成就',
    requirement: (state) => {
      const otherAchievements = ACHIEVEMENTS_LIST.filter(a => a.id !== 'true_master');
      return otherAchievements.every(a => state.unlockedAchievements.includes(a.id));
    },
    type: 'special',
    rarity: 'mythic',
    icon: '👑'
  }
];

// 📊 成就統計總覽
// 總計: 58 個成就
// - 敲擊成就: 8 個 (common: 2, uncommon: 2, rare: 1, epic: 1, legendary: 1, mythic: 1)
// - 連擊成就: 7 個 (common: 2, uncommon: 1, rare: 1, epic: 1, legendary: 1, mythic: 1)
// - 速度成就: 5 個 (common: 1, uncommon: 1, rare: 2, epic: 1)
// - 類型成就: 15 個 (uncommon: 6, rare: 5, epic: 4)
// - 自動成就: 6 個 (common: 2, uncommon: 2, rare: 1, epic: 1)
// - 特殊成就: 17 個 (common: 1, uncommon: 5, rare: 6, epic: 4, legendary: 1)